import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const loader = () =>
  import(/* webpackChunkName: "4-feat-live-persona-card-group" */ './LivePersonaCardGroupErrorBoundary');

export default lazyLoadOnRender({ loader });
